// 📄 pages/Proyectos/components/SolucionGate.tsx
// Envuelve el contenido de una solución (SLP, Sourcing, etc.): si no está
// en solucionesActivas del proyecto actual, muestra un mensaje claro en
// vez de la vista vacía/suelta que se veía antes.
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useProject } from '../../../context/ProjectContext.tsx';

interface Props {
  solucion: string;
  label: string;
  children: React.ReactNode;
}

export default function SolucionGate({ solucion, label, children }: Props) {
  const { project, projectId } = useProject();

  if (!project) return null;

  // Proyectos creados antes de este campo: se tratan como solo "commerce",
  // igual que en cualquier otro lugar que lea solucionesActivas.
  const activas = project.solucionesActivas || ['commerce'];

  if (!activas.includes(solucion)) {
    return (
      <div className="bg-white/5 border border-white/10 rounded-2xl p-10 text-center max-w-xl mx-auto">
        <Lock className="w-8 h-8 mx-auto mb-3 text-gray-500" />
        <h3 className="text-lg font-semibold text-white mb-2">
          Esta solución no está habilitada para este proyecto
        </h3>
        <p className="text-sm text-gray-400 mb-5">
          {label} no forma parte de las soluciones activas de este proyecto.
        </p>
        <Link
          to={`/proyecto/${projectId}/editar`}
          className="inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-lg text-sm font-semibold transition-all"
        >
          Habilitar en Editar Proyecto
        </Link>
      </div>
    );
  }

  return <>{children}</>;
}
